// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".show-message-radios[data-v-57406c6b]{-ms-flex-wrap:wrap;flex-wrap:wrap}.right-side[data-v-57406c6b]{margin-left:8px}.register-radio-label[data-v-57406c6b]{margin:0 8px 0 0!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
